var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3838 0.616251C14.2267 0.459113 14.0305 0.346686 13.8156 0.290551C13.6006 0.234415 13.3745 0.236598 13.1606 0.296876L13.1469 0.301251L1.15252 3.9375C0.908896 4.00814 0.692525 4.15122 0.53215 4.34775C0.371775 4.54428 0.274986 4.78495 0.254639 5.03779C0.234292 5.29063 0.291351 5.54368 0.418236 5.76333C0.54512 5.98297 0.735826 6.15882 0.965022 6.2675L6.23502 8.7675L8.73502 14.0375C8.83481 14.2516 8.99375 14.4326 9.19309 14.5593C9.39242 14.686 9.62384 14.753 9.86002 14.7525C9.89565 14.7525 9.9319 14.7525 9.96815 14.7481C10.2208 14.728 10.4612 14.6308 10.6569 14.4698C10.8526 14.3087 10.9941 14.0915 11.0625 13.8475L14.6988 1.85313C14.7006 1.84867 14.7021 1.84407 14.7031 1.83938C14.7634 1.62551 14.7656 1.39945 14.7095 1.18447C14.6533 0.96948 14.5409 0.773342 14.3838 0.616251ZM9.81252 12.8075L7.70502 8.35813L10.5331 5.53C10.674 5.38911 10.7532 5.19801 10.7532 4.99875C10.7532 4.79949 10.674 4.6084 10.5331 4.4675C10.3923 4.32661 10.2012 4.24745 10.0019 4.24745C9.80264 4.24745 9.61154 4.32661 9.47065 4.4675L6.64252 7.29563L2.19252 5.1875L13.125 1.875L9.81252 12.8075Z",
    fill: "#28BA59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardSent);
export default __webpack_public_path__ + "static/media/reward-sent.1cd7f901246607cff5f35a505afb31aa.svg";
export { ForwardRef as ReactComponent };